import React from 'react';
import '../styles/PhotoReview.css';

interface PhotoReviewProps {
  imageData: string;
  onApprove: () => void;
  onRetake: () => void;
  isUploading: boolean;
}

const PhotoReview: React.FC<PhotoReviewProps> = ({ 
  imageData, 
  onApprove, 
  onRetake,
  isUploading
}) => {
  return (
    <div className="photo-review">
      <div className="photo-container">
        <img src={imageData} alt="Captured" className="preview-image" />
      </div>
      <div className="review-controls">
        <button 
          onClick={onApprove} 
          className="approve-btn"
          disabled={isUploading}
        >
          {isUploading ? 'Uploading...' : 'Approve & Upload'}
        </button>
        <button 
          onClick={onRetake} 
          className="retake-btn"
          disabled={isUploading}
        >
          Retake
        </button>
      </div>
    </div>
  );
};

export default PhotoReview;